import { Component, Inject, Watch, Vue, Prop } from "vue-property-decorator";
import { CONTAINER_TYPES } from "../../infrastructure/ioc/container-types";
import ServiceInterface from "@/vue/service/service-interface";
import Utils from "@/vue/infrastructure/utils/helpers";
import DfProduct from "@/vue/domain/product/df-product";
import DfPromotion from "@/vue/domain/promotion/df-promotion";
import DfCategory from "@/vue/domain/category/df-category";
import DfPaging from "@/vue/domain/paging/df-paging";
import DfContent from "@/vue/domain/content/df-content";
import DfBrand from "@/vue/domain/brand/df-brand";

const DfCardProductComponent = () => Utils.externalComponent2("df-card-product");
const DfCardBannerComponent = () => Utils.externalComponent2("df-card-banner");

const lazyLoadingEnabled = process.env.VUE_APP_LAZY_LOADING_ENABLED;

@Component({
  components: {
    DfCardProduct: DfCardProductComponent,
    DfCardBanner: DfCardBannerComponent,
  },
})
export default class DfSectionProductsComponent extends Vue {
  @Inject(CONTAINER_TYPES.ServiceInterface)
  private service!: ServiceInterface;

  @Prop({ type: Object, default: null })
  promotion: DfPromotion;

  private lazyLoadingEnabled = true;

  beforeMount() {
    this.lazyLoadingEnabled = lazyLoadingEnabled === "true";
  }

  get selectedTags(): Array<DfCategory> {
    return this.$store.getters.activeTags;
  }

  get selectedCategory(): Array<DfCategory> {
    return this.$store.getters.activeCategory;
  }

  get productsQueryValue(): string {
    return this.$store.getters.productsQueryValue;
  }

  get products(): Array<DfProduct> {
    return this.$store.getters.products;
  }

  get banners(): Array<DfContent> {
    return this.$store.getters.promotionContents.filter((content: DfContent) => content.type.code === "BAN");
  }

  get bannersByPosition(): Array<DfContent> {
    return this.banners.filter((banner: DfContent) => {
      // TODO: Eliminare a inizio 2023
      const valueString: string = Utils.getPropertyValue(banner, Utils.PROPERTY_POSITION, "STRING");
      const valueList: any = Utils.getPropertyValue(banner, Utils.PROPERTY_POSITION, "LIST", {});

      return valueString === Utils.PROPERTY_BANNER_POSITION_PRODUCTS_LIST || valueList.key === "ALL" || valueList.key === Utils.PROPERTY_BANNER_POSITION_PRODUCTS_LIST;
    });
  }

  get elements(): Array<DfProduct | DfContent | any> {
    const elements: Array<DfProduct | DfContent | any> = [...this.products];
    this.bannersByPosition.forEach((banner: DfContent) => {
      if (banner.priority <= elements.length) {
        elements.splice(banner.priority, 0, banner);
      }
    });

    if (this.gamAdvSelexEnabled) {
      const selexRowBannerMobile: any = {
        advPath: `/23281620594/${this.gamAdvSelexEnvironment}/${this.gamAdvSelexBrand}/homepage/billboard_middle3`,
        class: "df-section-selex-row-banner",
      };
      const selexRowBannerDesktop: any = {
        advPath: `/23281620594/${this.gamAdvSelexEnvironment}/${this.gamAdvSelexBrand}/homepage/billboard_middle1`,
        class: "df-section-selex-row-banner",
      };
      const selexRowBanner: any = this.isMobile ? selexRowBannerMobile : selexRowBannerDesktop;

      const selexBoxBannerMobile: any = {
        advPath: `/23281620594/${this.gamAdvSelexEnvironment}/${this.gamAdvSelexBrand}/homepage/box_middle1`,
        class: "df-section-selex-box-banner",
      };
      const selexBoxBannerDesktop: any = {
        advPath: `/23281620594/${this.gamAdvSelexEnvironment}/${this.gamAdvSelexBrand}/homepage/box_middle3`,
        class: "df-section-selex-box-banner",
      };
      const selexBoxBanner: any = this.isMobile ? selexBoxBannerMobile : selexBoxBannerDesktop;

      const selexCard01Banner: any = {
        advPath: `/23281620594/${this.gamAdvSelexEnvironment}/${this.gamAdvSelexBrand}/homepage/box_sp_middle1`,
        class: "df-section-selex-card-banner df-card-banner-left",
      };
      const selexCard02Banner: any = {
        advPath: `/23281620594/${this.gamAdvSelexEnvironment}/${this.gamAdvSelexBrand}/homepage/box_sp_middle2`,
        class: "df-section-selex-card-banner df-card-banner-left",
      };
      const selexCard03Banner: any = {
        advPath: `/23281620594/${this.gamAdvSelexEnvironment}/${this.gamAdvSelexBrand}/homepage/box_sp_middle3`,
        class: "df-section-selex-card-banner df-card-banner-rigth",
      };
      const selexCard04Banner: any = {
        advPath: `/23281620594/${this.gamAdvSelexEnvironment}/${this.gamAdvSelexBrand}/homepage/box_sp_middle4`,
        class: "df-section-selex-card-banner df-card-banner-left",
      };

      let columns = 2;
      if (window.innerWidth >= 1400) {
        columns = 6;
      } else if (window.innerWidth >= 992) {
        columns = 4;
      } else if (window.innerWidth >= 768) {
        columns = 3;
      }
      const rows = Math.floor(this.products.length / columns);
      let minProductNrToShow = 0;

      if (this.isMobile) {
        minProductNrToShow = columns * 7;
      } else {
        minProductNrToShow = rows === 1 ? columns : columns * 2;
      }
      if (this.products.length >= minProductNrToShow) {
        if (this.isMobile) {
          selexRowBanner.class = `${selexRowBanner.class} df-row-start-7`;
        } else {
          selexRowBanner.class = rows === 1 ? `${selexRowBanner.class} df-row-start-2` : `${selexRowBanner.class} df-row-start-3`;
        }
        elements.push(selexRowBanner);
      }

      minProductNrToShow = columns * 5;
      if (this.isMobile && rows === 1) {
        minProductNrToShow = columns;
        selexBoxBanner.class = `${selexBoxBanner.class} df-row-start-2`;
      } else if (this.isMobile && rows === 2) {
        minProductNrToShow = columns * 2;
      }

      if (this.products.length >= minProductNrToShow) {
        elements.push(selexBoxBanner);
      }

      if (this.products.length > 0 && !this.isMobile) {
        elements.splice(0, 0, selexCard01Banner);
      }
      minProductNrToShow = columns * 7;
      if (this.products.length >= minProductNrToShow && !this.isMobile) {
        selexCard02Banner.class = `${selexCard02Banner.class} df-row-start-8`;
        elements.push(selexCard02Banner);
      }
      minProductNrToShow = columns * 9;
      if (this.products.length >= minProductNrToShow && !this.isMobile) {
        selexCard03Banner.class = `${selexCard03Banner.class} df-row-start-10`;
        elements.push(selexCard03Banner);
      }
      minProductNrToShow = columns * 11;
      if (this.products.length >= minProductNrToShow && !this.isMobile) {
        selexCard04Banner.class = `${selexCard04Banner.class} df-row-start-12`;
        elements.push(selexCard04Banner);
      }

    }
    return elements;
  }

  get customFiltersQuery(): Array<string> {
    return this.$store.getters.customFiltersQuery;
  }

  get isSearchActive(): boolean {
    const rule01: boolean = this.selectedTags.length > 0;
    const rule02: boolean = this.productsQueryValue && this.productsQueryValue.length > 0;
    const rule03: boolean = this.selectedCategory != null;
    const rule04: boolean = this.customFiltersQuery.length > 0;
    return rule01 || rule02 || rule03 || rule04;
  }

  get productsPaging(): DfPaging {
    return this.$store.getters.productsPaging;
  }

  get pagingPercentage() {
    return 100 * (this.products.length / this.productsPaging.totalElements);
  }

  get brand(): DfBrand {
    return this.$store.getters.brand;
  }

  get showProductsCounter(): boolean {
    return Utils.getPropertyValue(this.brand, Utils.PROPERTY_BRAND_SHOW_PRODUCTS_COUNTER, "BOOLEAN", true);
  }

  get isMobile(): boolean {
    return Utils.isMobile();
  }

  updated() {
    if (this.gamAdvSelexEnabled) {
      const event = new Event("updateDOMContent");
      document.dispatchEvent(event);
    }
  }

  private isBanner(element: DfProduct | DfContent): boolean {
    return element instanceof DfContent;
  }

  get gamAdvSelexEnabled(): boolean {
    return Utils.gamAdvSelexEnabled();
  }

  get gamAdvSelexEnvironment(): string {
    return Utils.gamAdvSelexEnvironment();
  }

  get gamAdvSelexBrand(): string {
    return Utils.gamAdvSelexBrand();
  }
}